import * as React from "react"
const SvgCost = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.927 19.602a.84.84 0 0 1-.606-.253.86.86 0 0 1-.259-.642V17.9a4.4 4.4 0 0 1-1.615-.791 3.7 3.7 0 0 1-1.071-1.312.87.87 0 0 1-.004-.746.91.91 0 0 1 .57-.52q.372-.127.737-.004.366.123.603.485.343.513.818.794t.931.282q.757 0 1.222-.384.465-.385.465-.904 0-.543-.46-.932-.459-.39-1.602-.771-1.724-.602-2.456-1.343-.732-.74-.732-1.912 0-.974.668-1.814.669-.84 1.926-1.098v-.786q0-.39.248-.643a.8.8 0 0 1 .596-.252q.36 0 .596.252a.9.9 0 0 1 .237.643v.786q.687.14 1.268.483.58.344.957.909a.81.81 0 0 1 .106.74.87.87 0 0 1-.524.549 1.06 1.06 0 0 1-.685.006q-.37-.11-.759-.45a1.27 1.27 0 0 0-.526-.335 2 2 0 0 0-.666-.112q-.646 0-1.05.305-.402.305-.402.74 0 .459.485.84.484.383 1.906.864 1.485.502 2.172 1.282t.687 2.05q0 1.17-.836 2.05t-2.133 1.111v.745a.9.9 0 0 1-.242.642.77.77 0 0 1-.57.253" />
  </svg>
)
export default SvgCost
